export default __webpack_public_path__ + "static/media/office-2.7cc369f7.jpg";